// Within this many minutes of the original estimate, a route counts as on schedule.
export const ON_SCHEDULE_TOLERANCE_MINUTES = 20;

export type EstimateStatus = "ahead" | "behind" | "onSchedule";

export type EstimateComparison = {
  status: EstimateStatus;
  /** Updated minus original: positive is behind, negative is ahead. */
  differenceMinutes: number;
};

export const compareWithOriginalEstimate = (
  updatedMinutes: number | undefined,
  originalMinutes: number | undefined,
): EstimateComparison | null => {
  if (
    updatedMinutes === undefined ||
    originalMinutes === undefined ||
    !Number.isFinite(updatedMinutes) ||
    !Number.isFinite(originalMinutes) ||
    originalMinutes <= 0
  ) {
    return null;
  }

  const differenceMinutes = updatedMinutes - originalMinutes;
  if (differenceMinutes > ON_SCHEDULE_TOLERANCE_MINUTES) {
    return { status: "behind", differenceMinutes };
  }
  if (differenceMinutes < -ON_SCHEDULE_TOLERANCE_MINUTES) {
    return { status: "ahead", differenceMinutes };
  }
  return { status: "onSchedule", differenceMinutes };
};
